export default __webpack_public_path__ + "images/nvent-brand-hoffman.png?0a425ec9798bbd596daf622a498af6cf";